/**
 * Единственное место, где решается «пускать ли в панель и кем» (B-1973, B-2175).
 *
 * До B-2175 гейт был размазан по трём точкам: `pages/login/index.tsx` (реальный
 * вход), `authProvider.login()` (в этом приложении не вызывается — ни `useLogin`,
 * ни `<AuthPage>` в `src` нет) и `authProvider.check()/getPermissions()`. Они
 * разошлись: ментору открыли `check()`, а страницу входа забыли, и роль
 * упиралась в «нет доступа к админ-панели». Чтобы это не повторилось, предикат
 * и производные от него живут здесь, а все точки входа зовут их.
 *
 * Правило доступа: `is_admin` (admin/super-admin монолита) ИЛИ `is_mentor`
 * (верифицированная анкета `Mentor` монолита, B-2221 — отдельной роли ментора
 * больше нет). Оба поля бэкенд отдаёт **всегда** и в
 * `POST /v1/auth/exchange-drafter`, и в `GET /v1/auth/me` (обязательные в схеме
 * `DrafterUserSummary`), `undefined` не бывает.
 */

/** Роль в панели. Админ шире ментора: ментору доступна только проверка ДЗ. */
export type AppRole = "admin" | "mentor";

/** Ролевые флаги пользователя — общая часть `DrafterUserSummary` и `/v1/auth/me`. */
export interface PanelRoleFlags {
  is_admin: boolean;
  is_mentor: boolean;
}

/** Есть ли у аккаунта хоть какой-то доступ в панель. */
export function hasPanelAccess(user: PanelRoleFlags | null | undefined): boolean {
  return panelRoleOf(user) !== null;
}

/** Роль аккаунта в панели; `null` — доступа нет (fail-closed на отсутствие данных). */
export function panelRoleOf(user: PanelRoleFlags | null | undefined): AppRole | null {
  if (!user) return null;
  if (user.is_admin) return "admin";
  if (user.is_mentor) return "mentor";
  return null;
}

/**
 * Куда вести пользователя после входа и на неизвестных маршрутах.
 * Админ — дашборд `/`, ментор — очередь ДЗ (дашборд ему закрыт `RoleGuard`'ом).
 */
export function homePathFor(role: AppRole | null): string {
  return role === "admin" ? "/" : "/homework";
}
